<template>

  <BasicLayout>
    <div class="elevation-4">
      <v-toolbar flat="flat">
        <v-toolbar-title>Sports</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-data-table hide-headers="hide-headers" hide-actions="hide-actions" :items="sportValues" :headers="columns">
        <template slot="items" slot-scope="props">
          <tr>
            <td>
              <SportLink :id="props.item.id" :showID="true"></SportLink>
            </td>
            <td class="sport-action"></td>
          </tr>
        </template>
      </v-data-table>
      <v-snackbar v-model="snackbar" color="error" :timeout="5000">{{ errorMessage }}</v-snackbar>
    </div>
  </BasicLayout>

</template>

<script>

import TableView from '@/components/common/TableView'
import TableLine from '@/components/common/TableLine'
import EditDeleteButtons from '@/components/common/EditDeleteButtons'
import BasicLayout from '@/layouts/BasicLayout'
import SportLink from '@/components/links/Sport'
import { mapGetters } from 'vuex'

export default {
  name: 'SportsPage',
  components: {
    TableView,
    TableLine,
    BasicLayout,
    EditDeleteButtons,
    SportLink
  },
  data () {
    return {
      columns: [{
        text: 'Sport'
      }, {
        text: 'Action',
        width: '200px'
      }],
      originalSport: null,
      snackbar: null,
      errorMessage: null
    }
  },
  computed: {
    ...mapGetters(['sportValues'])
  },
  mounted () {
    this.$store.dispatch('getSports')
  }
}

</script>

<style lang="scss" scoped>

@import '../../styles/main-colors.scss';

.box-header {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: 50px;
  align-items: center;
}

.sport-action {
  width: 50px;
}

</style>



// WEBPACK FOOTER //
// src/pages/sport/Sports.vue